import { render } from "./CurrencyInput.vue?vue&type=template&id=0603aa0c"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script